/* eslint-disable import/no-duplicates */
import {endOfDay} from 'date-fns/endOfDay';
import {startOfDay} from 'date-fns/startOfDay';
import {sub} from 'date-fns/sub';

type TPeriod = number | 'hours24' | 'anytime';

type TGetPeriod = (period?: TPeriod) => {
  period: TPeriod;
  startDate: Date | null;
  stopDate: Date | null;
};

const getPeriod: TGetPeriod = (period = 0) => {
  if (period === 'hours24') {
    const now = new Date();

    return {
      period,
      startDate: sub(now, {days: 1}),
      stopDate: now,
    };
  }

  if (period === 'anytime') {
    return {
      period,
      startDate: null,
      stopDate: null,
    };
  }

  const now = new Date();
  const startDate = sub(startOfDay(now), {days: period});
  const stopDate = sub(endOfDay(now), {days: period === 1 ? 1 : 0});

  return {
    period,
    startDate,
    stopDate,
  };
};

export default getPeriod;
/* eslint-enable import/no-duplicates */
